<template>
  <div>
    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-progress-circular
          indeterminate
          class="primary--text"
          :width="7"
          :size="70"
          v-if="loading"
        ></v-progress-circular>
      </v-flex>
    </v-layout>
    <bannerDog />                        

    <div class="container">
      <div class="row"></div>
      <v-layout>
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular
            indeterminate
            class="primary--text"
            :width="7"
            :size="70"
            v-if="loading"
          ></v-progress-circular>
        </v-flex>
      </v-layout>

      <div
        class="row"
        style="margin-right: 0px; margin-left: 0px"
        v-if="!loading"
      >
        <div
          class="col-md-4"
          v-for="dog in dogs"
          :key="dog.id"
          style="padding-left: 20px !important"
        >
          <div
            class="card blog-item mx-auto mb-3"
            v-if="dog"
            @click="onLoadDogs(dog.id)"
          >
            <div class="backgroundEffect"></div>
            <div class="pic">
              <img class="" :src="dog.images[0]" alt="" />
              <div class="date">
                <a
                  class="btn btn-primary pt-1 pb-1 pl-3 pr-3 float-right"
                  style="
                    color: white;
                    border-radius: 2px;
                    border: none;
                    font-size: 12px;
                    background-color: #ffd700;
                  "
                  v-if="dog.alive == false"
                  >In Memoriam</a
                >
                <a
                  class="btn btn-primary pt-1 pb-1 pl-3 pr-3 float-left"
                  style="
                    color: white;
                    border-radius: 2px;
                    border: none;
                    font-size: 12px;
                    background-color: #ffd700;
                  "
                  v-if="dog.dogForSale == true"
                  >Sale</a
                >
              </div>
            </div>
            <div class="content">
              <p class="h-1 mt-4">{{ dog.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import bannerDog from "@/components/bannerDog.vue";
export default {
  computed: {
    dogs() {
      return this.$store.getters.muskiPol;
    },
    user() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    onLoadDogs(id) {
      this.$router.push("/dogs/" + id);
    },
  },
  components: {
    Footer,
    bannerDog,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

* {
  padding: 0;

  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

body {
  margin-top: 30px;
  background-color: #eee;
}

.container {
  min-height: 100vh;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0px;
}
.layout {
  flex: none;
}
.card {
  width: 280px;
  height: 370px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: #fff;
  transition: all 0.5s ease;
  cursor: pointer;
  user-select: none;
  z-index: 10;
  overflow: hidden;
}

.card .backgroundEffect {
  bottom: 0;
  height: 0px;
  width: 100%;
}

.card:hover {
  color: #fff;
  transform: scale(1.025);
  box-shadow: rgba(0, 0, 0, 0.24) 0px 5px 10px;
}

.card:hover .backgroundEffect {
  bottom: 0;
  height: 320px;
  width: 100%;
  position: absolute;
  z-index: -1;
  background: #ffd700;
  animation: popBackground 0.3s ease-in;
}

@keyframes popBackground {
  0% {
    height: 20px;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
  }

  50% {
    height: 80px;
    border-top-left-radius: 75%;
    border-top-right-radius: 75%;
  }

  75% {
    height: 160px;
    border-top-left-radius: 85%;
    border-top-right-radius: 85%;
  }

  100% {
    height: 320px;
    border-top-left-radius: 100%;
    border-top-right-radius: 100%;
  }
}

.card .pic {
  position: relative;
}

.card .pic img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.card .date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 70px;
  margin-left: 10px;
  color: white;
  position: absolute;
  bottom: 0px;
  transition: all ease;
}

.card .date .day {
  font-size: 14px;
  font-weight: 600;
}

.card .date .month,
.card .date .year {
  font-size: 10px;
}

.card .text-muted {
  font-size: 12px;
}

.card:hover .text-muted {
  color: #fff !important;
}

.card .content {
  padding: 0 20px;
}

.card .content .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background-color: #ffd700;
  border-radius: 25px;
  font-size: 12px;
  border: none;
}

.card:hover .content .btn {
  background: #fff;
  color: #ffd700;
  box-shadow: #0000001a 0px 3px 5px;
}

.card .content .btn .fas {
  font-size: 10px;
  padding-left: 5px;
}

.card .content .foot .admin {
  color: #ffd700;
  font-size: 12px;
}

.card:hover .content .foot .admin {
  color: #fff;
}

.card .content .foot .icon {
  font-size: 12px;
}
</style>
